define('views/modules/stats/stat',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/stats/week-stat',
    // templates
    'text!templates/modules/stats/stat.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MWeekStat,
    // templates
    TStat
) {

    var VStat = Backbone.View.extend({
        template: TStat,
        className: 'ucolfix',

        initialize: function(opt) {
            opt = opt || {};

            this.profile = opt.profile;

            var model = this.model = new MWeekStat();
            this.listenTo(model, { 'change': this.onModelChange });
        },

        render: function() {
            var model = this.model;
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext(_.extend(model.toJSON(), {
                    unit: model.isDistance() ? this.profile.get('distanceUnit') : model.getUnit(),
                    label: model.getLabel()
                }))));
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        onModelChange: function(model) {
            this.render();
        },
    });

    return VStat;

});

